module.exports = __webpack_public_path__ + "img/buzon-pld.e34cf9a8.svg";